import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {toPayload} from '../lib/types/payload'
import {ContentfulIndex} from './copilot/ContentfulIndex'
import {DefaultIndex} from './copilot/DefaultIndex'
import resolveResponse from 'contentful-resolve-response'
import {isFeatureCopilotPage, toContainerPage, toEntryCollection} from '../lib/types/contentful'

export function CopilotIndex() {
  const {copilotSignupPath} = useRoutePayload<{copilotSignupPath: string}>()
  const {copilotForBusinessSignupPath} = useRoutePayload<{copilotForBusinessSignupPath: string}>()
  const {copilotContactSalesPath} = useRoutePayload<{copilotContactSalesPath: string}>()
  const {copilotHeroSignupPath} = useRoutePayload<{copilotHeroSignupPath: string}>()
  const {isCopilotPlansPageEnabled} = useRoutePayload<{isCopilotPlansPageEnabled: boolean}>()
  const {inShowVideoTreatment} = useRoutePayload<{inShowVideoTreatment: boolean}>()
  const {copilotHydroTracking} = useRoutePayload<{copilotHydroTracking: string}>()
  const {copilotVideoHydroTracking} = useRoutePayload<{copilotVideoHydroTracking: string}>()
  const {copilotConvoHydroTracking} = useRoutePayload<{copilotConvoHydroTracking: string}>()
  const {copilotSuggestionsHydroTracking} = useRoutePayload<{copilotSuggestionsHydroTracking: string}>()
  const {copilotDocsHydroTracking} = useRoutePayload<{copilotDocsHydroTracking: string}>()
  const {copilotPullRequestsHydroTracking} = useRoutePayload<{copilotPullRequestsHydroTracking: string}>()
  const {contentfulRawJsonResponse} = toPayload(useRoutePayload<unknown>())

  // empty hash {} when contentful is disabled
  if (Object.keys(contentfulRawJsonResponse).length > 0) {
    const page = toContainerPage(toEntryCollection(resolveResponse(contentfulRawJsonResponse)).at(0))

    if (isFeatureCopilotPage(page)) {
      return (
        <ContentfulIndex
          copilotSignupPath={copilotSignupPath}
          copilotForBusinessSignupPath={copilotForBusinessSignupPath}
          copilotContactSalesPath={copilotContactSalesPath}
          copilotHeroSignupPath={copilotHeroSignupPath}
          isCopilotPlansPageEnabled={isCopilotPlansPageEnabled}
          inShowVideoTreatment={inShowVideoTreatment}
          copilotHydroTracking={copilotHydroTracking}
          contentfulRawJsonResponse={contentfulRawJsonResponse}
          page={page}
        />
      )
    }
  }

  return (
    <DefaultIndex
      copilotSignupPath={copilotSignupPath}
      copilotForBusinessSignupPath={copilotForBusinessSignupPath}
      copilotContactSalesPath={copilotContactSalesPath}
      copilotHeroSignupPath={copilotHeroSignupPath}
      isCopilotPlansPageEnabled={isCopilotPlansPageEnabled}
      copilotHydroTracking={copilotHydroTracking}
      copilotVideoHydroTracking={copilotVideoHydroTracking}
      copilotConvoHydroTracking={copilotConvoHydroTracking}
      copilotSuggestionsHydroTracking={copilotSuggestionsHydroTracking}
      copilotDocsHydroTracking={copilotDocsHydroTracking}
      copilotPullRequestsHydroTracking={copilotPullRequestsHydroTracking}
    />
  )
}

try{ CopilotIndex.displayName ||= 'CopilotIndex' } catch {}